import React from 'react';
import { Icon } from '@blueprintjs/core';
import { SettingsCard } from 'components/SettingsPage';

// What every plan has no cap on.
const UNLIMITED = [
  { icon: 'people', label: 'User seats' },
  { icon: 'wrench', label: 'Jobs' },
  { icon: 'document', label: 'Work orders' },
];

// What's included, and what isn't.
const FEATURES = [
  { icon: 'time', label: 'Time tracking', included: true },
  { icon: 'drive-time', label: 'Scheduling and dispatch', included: true },
  { icon: 'projects', label: 'Job costing, estimates and proposals', included: true },
  { icon: 'person', label: 'Customer CRM', included: true },
  { icon: 'geolocation', label: 'GPS routing', included: true },
  { icon: 'draw', label: 'Service agreements', included: true },
  { icon: 'form', label: 'Job forms', included: true },
  { icon: 'mobile-phone', label: 'iOS and Android mobile apps', included: true },
  { icon: 'chart', label: 'Reporting', included: true },
  { icon: 'offline', label: 'Offline access from the apps', included: false },
];

// Billing > Overview: what the subscription includes and how it's billed.
const BillingOverview = () => (
  <React.Fragment>
    <SettingsCard title="What's included" description="Everything that comes with your subscription.">
      <ul className="bill-unlimited" aria-label="Unlimited">
        {UNLIMITED.map((item) => (
          <li key={item.label} className="bill-unlimited__item">
            <Icon icon={item.icon} iconSize={16} aria-hidden="true" />
            <span className="bill-unlimited__label">{item.label}</span>
            <span className="bill-unlimited__value">Unlimited</span>
          </li>
        ))}
      </ul>
      <ul className="bill-features" aria-label="Features">
        {FEATURES.map((feature) => (
          <li key={feature.label} className={`bill-feature${feature.included ? '' : ' is-excluded'}`}>
            <Icon icon={feature.included ? 'tick-circle' : 'disable'} iconSize={14} aria-hidden="true" />
            <span>{feature.label}</span>
            <span className="sr-only">{feature.included ? 'Included' : 'Not included'}</span>
            {!feature.included && <span className="bill-feature__note" aria-hidden="true">Not included</span>}
          </li>
        ))}
      </ul>
    </SettingsCard>

    <SettingsCard title="How billing works">
      <div className="bill-text">
        <p>
          Billing is based only on the number of users using the software. If your number of users goes up or
          down in a month, that month's charges are adjusted automatically.
        </p>
        <p>For each billing cycle (30 days), you're emailed an invoice with the charges and any taxes that apply.</p>
        <p>
          Questions about your bill? Email{' '}
          <a href="mailto:support@fieldnexus.com">support@fieldnexus.com</a>.
        </p>
      </div>
    </SettingsCard>
  </React.Fragment>
);

export default BillingOverview;
